<!-- 集控器下变量管理 -->
<template>
    <div class='container containerBox'>
        <!-- 头部筛选区 -->
        <div class="handleForm">
            <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="集控器">
                    <el-select v-model="form.collector" placeholder="请选择集控器"  @change="handleChageCollect">
                        <el-option
                            v-for="item in collectorList"
                            :key="item.oid"
                            :label="item.dev_name"
                            :value="item.oid">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备">
                    <el-select v-model="form.device" placeholder="请选择设备"  @change="handleChageb">
                        <el-option
                            v-for="item in deviceList"
                            :key="item.oid"
                            :label="item.device_model+'：'+item.terminal_serial"
                            :disabled="item.dev_type != 4"
                            :value="item.oid">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="变量地址">
                    <el-input v-model="form.var_Initial_addr" placeholder="请输入变量地址"></el-input>
                </el-form-item>
                <el-form-item >
                    <el-button type="primary" @click="handleExport">导出全部变量</el-button>
                </el-form-item>
                <el-form-item >
                    <el-button type="primary" @click="onSubmit">查询</el-button>
                </el-form-item>
            </el-form>
        </div>

        <lb-table v-loading="loading"
            :column="tableData.column"
            :data="tableData.data"
            :height="maxHeight"
            stripe
            pagination
            layout="total, sizes, prev, pager, next, jumper"
            :page-sizes="[10, 20, 50, 100]"
            :current-page.sync="page_num"
            :total="total"
            :page-size="page_sum"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange">
        </lb-table>
    </div>
</template>

<script>
import LbTable from '@/components/lb-table/lb-table'
import { getMaxHeigth } from '@/utils/utils'
import Service from '@/api/Service'
import config from '@/config'
import { fmtDoubleByte, fmtInt32Byte,hex2float}  from '@/utils/HexToSingleBatch.js'


export default {
    name:  'argmana',
    data() {
        return {
            form: {
                device: '',
                collector: '',
                var_Initial_addr: '',
            },

            collectorList: [], // 集控器列表
            deviceList: [], // 设备列表

            tableData: {
                column: [
                    {
                        type: 'selection',
                    },
                    {
                        prop: 'var_name',
                        label: '变量名称',
                        sortable: true,
                    },
                    {
                        prop: 'opcode',
                        label: '操作码',
                        render: (h, scope) => {
                            return (
                                <div>
                                    {this.fmtAddr(scope.row.opcode)}
                                </div>
                            )
                        }
                    },
                    {
                        prop: 'var_type',
                        label: '变量类型',
                        render: (h, scope) => {
                            return (
                                <div>
                                    {this.fmtType(scope.row.var_type)}
                                </div>
                            )
                        }
                    },
                    {
                        prop: 'var_Initial_addr',
                        label: '变量地址',
                        sortable: true,
                    },
                    {
                        prop: 'curValue',
                        label: '当前状态'
                    },
                    {
                        prop: 'var_0_represent',
                        label: '为0状态'
                    },
                    {
                        prop: 'var_1_represent',
                        label: '为1状态'
                    },
                    {
                        prop: 'unit',
                        label: '单位'
                    },
                ],
                data: []
            },
            loading: false,
            multipleSelection: [],
            maxHeight: 500,
            total: 0,
            page_num: 1,
            page_sum: 10,

            ws_data: {},
			plcdata: {}
        };
    },

    components: { LbTable },

    computed: {},

    mounted() {
        this.$nextTick(()=>{
            this.maxHeight = getMaxHeigth();
        })
    },

    async created() {
        await this.getList();
        this.getData()
    },

    methods: {
        // 获取集控器列表
        async getList() {
            this.loading = true;
            let data = await Service.getCollector();
            this.loading = false;
            if(data){
                data = data === 'success' ? [] : data;
                this.collectorList = data;
                this.form.collector = data[0].oid;
                this.getDeviceList(this.form.collector);
            }
        },
		//获取设备列表
        async getDeviceList(oid) {
            // let { oid } = obj
            let { page_num, page_sum } = this;
            let params = Object.assign({}, { page_num, page_sum }, {OID: oid});
            let data = await Service.getMeter(params);
            if(data) {
                let list = data.list == null ? [] : data.list;
                this.deviceList = list;
                if(list.length>0) {
                    this.form.device = list[0].oid;
                    await this.getCurrentReading();
                    this.getData();
                }
            }
        },
        async getData() {
            let terminal_id = this.form.device
            let var_Initial_addr = this.form.var_Initial_addr
            if(terminal_id === '') return
            let { page_num, page_sum } = this;
            let params = {
                terminal_id,
                var_Initial_addr,
                page_num,
                page_sum,
            }
            let res = await Service.getPlcConfig(params);
            if(res) {
                let list = res.list === null ? [] : res.list;
				if(list.length == 1){
					if(list[0].var_type == 3 || list[0].var_type == 4){
						list[1]= {opcode:list[0].opcode,var_Initial_addr:list[0].var_Initial_addr + 1}
					}
				}
                list.map(v=>{
					var str = JSON.stringify(v.var_Initial_addr) + "_" + JSON.stringify(v.opcode)
					for(var key in this.plcdata){						
						if(key == str){
							v.curValue = this.plcdata[key]
							break;
						}else{
							v.curValue = ''
						}
					}
                })
                this.total = res.total;
				this.tableData.data = list;
            }
        },
        handleChageCollect(val) {
            this.getDeviceList(this.form.collector)
        },
		async handleChageb(val){
			this.form.device = val;
			await this.getCurrentReading()
			await this.getData()
		},
        // 获取PLC当前数据
        async getCurrentReading(){
            let oid = this.form.device;
            let res = await Service.getPlcCurrentReadings({oid});
			
            if(res){
               let data = res.data || []
				this.plcdata = data
				this.ws_data = data
            }
        },
        onSubmit() {
			this.page_num = 1
			this.getDeviceList(this.form.collector)
        },
        handleSizeChange (val) {
            this.page_num = 1
            this.page_sum = val
            this.getData()
        },
        handleCurrentChange (val) {
            if(isNaN(val)) return
            if(val === null) return
            this.page_num = val
            this.getData()
        },
        fmtAddr(qrcode) {
            switch (qrcode) {
                case 1:
                    return "01"
                case 3:
                    return "03"
                case 5:
                    return "05"
                case 6:
                    return "06"
                default:
                    return ""
            }
        },
        fmtType(var_type) {
            switch (var_type) {
                case 1:
                    return "int16"
                case 2:
                    return "bool"
                case 3:
                	return "int32"
                case 4:
                	return "float"
                case 5:
                	return "uint16"	
                case 6:
                	return "uint32"	
            }
        },

        // 导出
        async handleExport() {
            let terminalid = this.form.device
            let res = await Service.exportPlcConfig({terminalid})
            if(res) {
                location.href = config.DEFAULT_FILE_PATH + res
            }
        },
    }
}

</script>
<style lang='less' scoped>
   
</style>

